import { CartItem } from './cart';
import { ErrorResponse } from './types';
import { IEntityCartItem } from '../reducers/cartSlice.props';

export const getErrorMessages = (errorResponse: ErrorResponse) => {
  return errorResponse.message;
};

// Generic customer-facing explanation sent (as TTS) when the agent clicks a
// failed order line. A menu-module failure names the item that couldn't be
// added; a POSMON/POSLINK failure covers the whole order submission.
export const getOrderErrorMessage = (
  cartItem: CartItem | IEntityCartItem,
  isMenuModuleError: boolean
) =>
  isMenuModuleError
    ? `I have trouble to add ${cartItem.name}.`
    : 'I have trouble to submit your order.';
